export default function settingsReducer(settingsContext, action){
	switch (action.type) {
    case 'expandForm': {
      return {
        ...settingsContext,
        isFormExpanded: action.isFormExpanded
      }
    }
    case 'expandReply': {
      return {
        ...settingsContext,
        expandedReply: action.expandedReply
      }
    }
    case 'resolveUser': {
      return {
        ...settingsContext,
        ...action.payload
      }
    }
    case 'isLoading': {
      return {
        ...settingsContext,
        isLoading: action.isLoading
      }
    }
    case 'update': {
      return {
        ...settingsContext,
        ...action.payload
      }
    }
    default: {
      throw Error('Unknown settings action: ' + action.type);
    }
  }
}